import { render, staticRenderFns } from "./ActivityLogButton.vue?vue&type=template&id=864e1d1a&scoped=true"
import script from "./ActivityLogButton.vue?vue&type=script&lang=js"
export * from "./ActivityLogButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864e1d1a",
  null
  
)

export default component.exports